export default __webpack_public_path__ + "static/media/bell1.8a00b7ab.svg";